import { useUnassignOrderSerialMutation } from "app/api/checklists";
import SimpleDialog from "components/SimpleDialog";
import { Product } from "models/Product";
import { toast } from "react-toastify";

type UninstallProductDialogProps = {
  product: Product;
  checklistId: string;
  orderId: string;
  onClose: () => void;
};

const UninstallProductDialog: React.FC<UninstallProductDialogProps> = (props) => {
  const { product, checklistId, orderId, onClose } = props;

  const [uninstallOrderSerial, { isLoading }] = useUnassignOrderSerialMutation();

  return (
    <SimpleDialog
      onClose={onClose}
      onConfirm={async () => {
        await uninstallOrderSerial({
          serialId: product.id,
          checklistId: checklistId,
          orderId: orderId,
        }).catch((error: any) => {
          toast.error("Kunde inte avinstallera produkten");
          console.error("Error uninstalling product:", error);
        });
        onClose();
      }}
      title="Avinstallera produkten?"
      message="Produkten kommer att tas bort från checklistan, men finnas kvar på ordern."
      confirmProps={{
        children: "Avinstallera",
      }}
      loading={isLoading}
    />
  );
};

export default UninstallProductDialog;
